import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledActionButton = styledWithTheme.div(({
  theme
}) => ({
  cursor: 'pointer',
  backgroundColor: theme.color['fill-surface-default'],
  '&:hover': {
    backgroundColor: theme.color['fill-tertiary-hover']
  },
  paddingInline: theme.space['500'],
  paddingBlock: theme.space['200']
}));
export const PopoverActionButton = props => /*#__PURE__*/_jsx(StyledActionButton, Object.assign({
  role: "button"
}, props));
PopoverActionButton.displayName = 'PopoverActionButton';